import { render, staticRenderFns } from "./consumeOrderList.vue?vue&type=template&id=0fe0902b&scoped=true&"
import script from "./consumeOrderList.vue?vue&type=script&lang=js&"
export * from "./consumeOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe0902b",
  null
  
)

export default component.exports